import { render, staticRenderFns } from "./DaoVotingsView.vue?vue&type=template&id=d0e11fb0&scoped=true&"
import script from "./DaoVotingsView.vue?vue&type=script&lang=js&"
export * from "./DaoVotingsView.vue?vue&type=script&lang=js&"
import style0 from "./DaoVotingsView.vue?vue&type=style&index=0&id=d0e11fb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e11fb0",
  null
  
)

export default component.exports